import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import SelectField from "components/SelectField";
import { memo } from "react";
import DatepickerField from "components/DatepickerField";
import SwitchField from "components/SwitchField";
import FormNumberField from "components/FormNumberField";

/* eslint-disable react/prop-types */

function Fields2({ formData }) {
  const { formField2, values, errors, touched } = formData;
  const { taxpayerName, taxId, taxAgencyId, taxAgencyName } = formField2;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxpayerName.name}
            label={taxpayerName.label}
            value={values.taxpayerName}
            error={errors.taxpayerName && touched.taxpayerName}
            success={values.taxpayerName?.toString().length > 0 && !errors.taxpayerName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxId.name}
            label={taxId.label}
            value={values.taxId}
            error={errors.taxId && touched.taxId}
            success={values.taxId?.toString().length > 0 && !errors.taxId}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgencyName.name}
            label={taxAgencyName.label}
            value={values.taxAgencyName}
            error={errors.taxAgencyName && touched.taxAgencyName}
            success={values.taxAgencyName?.toString().length > 0 && !errors.taxAgencyName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgencyId.name}
            label={taxAgencyId.label}
            value={values.taxAgencyId}
            error={errors.taxAgencyId && touched.taxAgencyId}
            success={values.taxAgencyId?.toString().length > 0 && !errors.taxAgencyId}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default memo(Fields2);
